import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store/store';
import { setAffiliatesJoinPopupOpen } from '../../../store/features/affiliatesSlice';
import { setAuthPopupOpen } from '../../../store/features/common';
import { AuthPopupContentType } from '../../auth/types';

export function useAffiliateNavigation() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleAffiliateNavigation = (isAuthenticated: boolean, profile: any) => {
    if (isAuthenticated && profile?.affiliateLink) {
      navigate("/profile");
    } else if (isAuthenticated && !profile?.affiliateLink) {
      dispatch(setAffiliatesJoinPopupOpen());
    } else {
      dispatch(setAuthPopupOpen(AuthPopupContentType.SIGNUP));
    }
  };

  return { handleAffiliateNavigation };
}